import { render } from "./UpdateTemplate.vue?vue&type=template&id=4a927f72&scoped=true"
import script from "./UpdateTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateTemplate.vue?vue&type=script&lang=js"

import "./UpdateTemplate.vue?vue&type=style&index=0&id=4a927f72&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a927f72"]])

export default __exports__